<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="planoContaEmpresa">Especificação</label>
                            <p-dropdown
                                [options]="planosContaEmpresa"
                                optionLabel="descricao"
                                placeholder="Selecione"
                                name="planoContaEmpresa"
                                ngModel
                                #planoContaEmpresa="ngModel"
                                [filter]="true"
                                [required]="true"
                            ></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="identificacao">Identificação</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Insira a Identificação"
                                name="identificacao"
                                ngModel
                                #identificacao="ngModel"
                            />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataVencimento">Vencimento</label>
                            <p-calendar
                                placeholder="Selecione"
                                [readonlyInput]="true"
                                [showIcon]="true"
                                dateFormat="dd/mm/yy"
                                [showButtonBar]="true"
                                name="dataVencimento"
                                ngModel
                                #dataVencimento="ngModel"
                                [required]="true"
                            ></p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="competencia">Competência</label>
                            <p-calendar
                                placeholder="Selecione"
                                view="month"
                                dateFormat="mm/yy"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                name="competencia"
                                ngModel
                                #competencia="ngModel"
                            ></p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorFluxo">Valor Despesa</label>
                            <p-inputNumber
                                name="valorFluxo"
                                ngModel
                                #valorFluxo="ngModel"
                                mode="currency"
                                inputId="currency-brazil"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                            ></p-inputNumber>
                            <div *ngIf="valorFluxo.touched && valorFluxo.value <= 0" class="alerta">
                                Insira o Valor
                            </div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="tipoPagamento">Forma de Pagamento</label>
                            <p-dropdown
                                [options]="tiposPagamento"
                                optionLabel="descricao"
                                placeholder="Selecione"
                                name="tipoPagamento"
                                ngModel
                                #tipoPagamento="ngModel"
                                [filter]="true"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataFluxo">Data Pagamento</label>
                            <p-calendar
                                placeholder="Selecione"
                                [readonlyInput]="true"
                                [showIcon]="true"
                                dateFormat="dd/mm/yy"
                                [showButtonBar]="true"
                                name="dataFluxo"
                                ngModel
                                #dataFluxo="ngModel"
                                (ngModelChange)="selecionarData(dataFluxo.value)"
                            ></p-calendar>
                            <div *ngIf="agendamentoPagamento" class="alerta">
                                <small>Pagamento será agendado</small>
                            </div>
                        </div>
                        <div
                            class="field col-12 md:col-3"
                            *ngIf="planoContaEmpresa.value?.codigo === 22"
                        >
                            <label htmlFor="controle">Selecione o Fornecedor</label>
                            <p-dropdown
                                [options]="fornecedores"
                                optionLabel="nomeFornecedor"
                                optionValue="id"
                                placeholder="Selecione"
                                name="controle"
                                ngModel
                                emptyMessage="Sem Fornecedores"
                                #controle="ngModel"
                                [filter]="true"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Pagar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!f.valid || valorFluxo.value <= 0"
                                (click)="salvar()"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="button"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Pagar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/pagamento-despesa"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
